<template>
  <footer class="emd-footer">
    <div class="emd-chunk">
      <p class="emd-text _align_center">
        <emd-pagarme-icon />
        <span class="emd-text _color_nonessential">|</span>
        <emd-security-tag />
      </p>
    </div>
    <div class="emd-chunk">
      <div class="emd-flex _justify_center">
        <div class="emd-flex-item _basis_1">
          <emd-language-select />
        </div>
      </div>
    </div>
  </footer>
</template>
<script>
import EmdLanguageSelect from './EmdLanguageSelect.vue'
import EmdPagarmeIcon from './EmdPagarmeIcon.vue'
import EmdSecurityTag from './EmdSecurityTag.vue'
export default {
  name: 'EmdExternalFooter',
  components: {
    EmdLanguageSelect,
    EmdPagarmeIcon,
    EmdSecurityTag
  }
}
</script>
